import React from "react";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import styles from "./ShareBtns.module.css";
import mainStyles from "../Charts.module.css";
import screenshotImg from "../../../assets/images/common/icons/screenshot.svg";
import videoImg from "../../../assets/images/common/icons/video.svg";

const ShareBtns = ({ title, showDownloadBtns, clickOnScreen, clickOnVideo, className, ...props }) => {
  const url = document.location.href;
  return (
    <div className={styles.btnsRow + (className ? " " + className : "")}>
      <FacebookShareButton quote={title} url={url}>
        <FacebookIcon size={30} round />
      </FacebookShareButton>

      <TwitterShareButton url={url} title={title} hashtag="#f1">
        <TwitterIcon size={30} round />
      </TwitterShareButton>

      <WhatsappShareButton title={title} separator=":: " url={url}>
        <WhatsappIcon size={30} round />
      </WhatsappShareButton>

      <EmailShareButton subject={"F1-informer"} body={title} url={url}>
        <EmailIcon size={30} round />
      </EmailShareButton>

      {showDownloadBtns && (
        <>
          <button className={styles.screenshotBtn} onClick={clickOnScreen}>
            <img className={styles.screenshotImg} src={screenshotImg} alt={"Screen"} />
          </button>
          <button className={styles.recordBtn} onClick={clickOnVideo}>
            <img className={styles.recordImg} src={videoImg} alt={"Screen"} />
          </button>
        </>
      )}
    </div>
  );
};

export default ShareBtns;
